import api from "./api";

export const fetchOrders = async () => {
  try {
    const response = await api.get("/orders");
    return response.data;
  } catch (error) {
    console.error("Error fetching orders", error);
  }
};
export const fetchGttOrders = async () => {
  try {
    const response = await api.get("/orders/gtt");
    return response.data;
  } catch (error) {
    console.error("Error fetching Gtt orders", error);
  }
};
export const fetchHoldings = async () => {
  try {
    const response = await api.get("/portfolio/holdings");
    return response.data;
  } catch (error) {
    console.error("Error fetching holdings", error);
  }
};
export const fetchPositions = async () => {
  try {
    const response = await api.get("/portfolio/positions");
    return response.data;
  } catch (error) {
    console.error("Error fetching positions", error);
  }
};
